const langPackLocalVersion = 8;export default langPackLocalVersion;
